export default __webpack_public_path__ + "assets/0a2a05f17475f4e3fd47aaf42aa9b800.png";